import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resetSystemTheme } from '../../utils/ecommerceHelper';

const StoreInSetup = ({ storeConfig }) => {
  useEffect(() => {
    resetSystemTheme();
  }, []);

  const isHiperpelHost = typeof window !== 'undefined' && window.location.hostname.toLowerCase().includes('hiperpel');
  const sanitizeName = (val) => {
    const str = (val || '').trim();
    if (!str) return '';
    if (!isHiperpelHost && str.toLowerCase().includes('hiperpel')) return '';
    return str;
  };

  const companyName =
    sanitizeName(storeConfig?.company_name) ||
    sanitizeName(storeConfig?.logoText) ||
    sanitizeName(storeConfig?.footer?.companyName) ||
    'Tienda Online';

  const rawEmail = (storeConfig?.footer?.email || storeConfig?.email || '').trim();
  const companyEmail = (!isHiperpelHost && rawEmail.toLowerCase().includes('hiperpel')) ? '' : rawEmail;
  const sisgecomEmail = 'soporte@sisgecom.ar';

  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      {/* NAVBAR FIJA IDÉNTICA AL SISTEMA */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
        <div className="container-fluid px-4">
          <span className="navbar-brand fw-bold text-primary mb-0">
            SISGECOM <small className="text-white fw-light">v1.0</small>
          </span>

          <Link to="/login" className="btn btn-outline-primary btn-sm d-flex align-items-center">
            <i className="bi bi-box-arrow-in-right me-1"></i> Ingreso al Sistema
          </Link>
        </div>
      </nav>

      {/* CARD CENTRAL CON EL MISMO ESTILO DE LOGIN.JS */}
      <div className="container d-flex justify-content-center align-items-center flex-grow-1 py-4">
        <div className="card shadow border-0" style={{ width: '100%', maxWidth: '440px' }}>
          <div className="card-body p-5 text-center">
            <h2 className="text-center mb-1 fw-bold text-primary">SISGECOM</h2>
            <p className="text-center text-muted mb-4">Sistema de Gestión Comercial</p>

            <div className="p-3 bg-light rounded border mb-4">
              <span className="badge bg-warning text-dark mb-2 px-3 py-2">
                <i className="bi bi-clock-history me-1"></i>
                En proceso de habilitación
              </span>
              <h5 className="fw-bold text-dark mt-2 mb-2">{companyName}</h5>
              <p className="text-muted small mb-0">
                La tienda se encuentra en proceso de habilitación. Comuníquese con un administrador para obtener más información al respecto.
              </p>
            </div>

            <div className="mb-4">
              <p className="form-label fw-semibold small text-muted mb-2">
                Atención por correo electrónico
              </p>

              {companyEmail && (
                <a
                  href={`mailto:${companyEmail}?subject=${encodeURIComponent(`Consulta Tienda ${companyName}`)}`}
                  className="btn btn-outline-secondary w-100 py-2 mb-2 d-flex align-items-center justify-content-center gap-2 fw-semibold"
                >
                  <i className="bi bi-envelope"></i>
                  <span>{companyEmail}</span>
                </a>
              )}

              <a
                href={`mailto:${sisgecomEmail}?subject=${encodeURIComponent(`Consulta Habilitación Tienda - ${companyName}`)}`}
                className="btn btn-outline-primary w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-semibold"
              >
                <i className="bi bi-envelope-fill"></i>
                <span>{sisgecomEmail}</span>
              </a>
            </div>

            <Link to="/login" className="btn btn-primary w-100 py-2 fw-bold">
              Iniciar Sesión
            </Link>
          </div>

          <div className="card-footer text-center text-muted small py-3 bg-light border-0">
            v1.0 &bull; Estudio AP&B
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreInSetup;
